var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultZoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "zoom_out_FILL0_wght400_GRAD0_opsz48",
    d: "M136.9-823l-6.575-6.575a5.513,5.513,0,0,1-1.749,1.013,6.184,6.184,0,0,1-2.126.362,6.223,6.223,0,0,1-4.577-1.875A6.169,6.169,0,0,1,120-834.6a6.166,6.166,0,0,1,1.875-4.525A6.181,6.181,0,0,1,126.413-841a6.14,6.14,0,0,1,4.525,1.875A6.191,6.191,0,0,1,132.8-834.6a6.226,6.226,0,0,1-.35,2.071,6.348,6.348,0,0,1-1.05,1.875l6.6,6.55Zm-10.475-6.7a4.676,4.676,0,0,0,3.453-1.438A4.746,4.746,0,0,0,131.3-834.6a4.746,4.746,0,0,0-1.422-3.463,4.675,4.675,0,0,0-3.453-1.437,4.748,4.748,0,0,0-3.489,1.438A4.721,4.721,0,0,0,121.5-834.6a4.721,4.721,0,0,0,1.436,3.462A4.748,4.748,0,0,0,126.425-829.7Zm-2.55-4.175v-1.5H128.9v1.5Z",
    transform: "translate(-120 841)",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultZoom);
export default __webpack_public_path__ + "static/media/default-zoom.0dca76c0.svg";
export { ForwardRef as ReactComponent };